import { render, staticRenderFns } from "./SymposiaList.vue?vue&type=template&id=5d527de4&scoped=true"
import script from "./SymposiaList.vue?vue&type=script&lang=js"
export * from "./SymposiaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d527de4",
  null
  
)

export default component.exports